import styled from "styled-components";

/**
 * Wrapper principal do conteúdo de busca
 */
export const SearchContentWrapperMobile = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  flex-direction: column;
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const RadioWrapperMobile = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
  height: ${({ theme }) => theme.spacing(8)};
  gap: ${({ theme }) => theme.spacing(4)};
  display: flex;

  & span {
    color: ${({ theme }) => theme.colors.darkGray};
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const ContentWrapperMobile = styled.div`
  flex-direction: column;
  display: flex;

  & > button {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.spacing(1.5)};
  }
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const DatasSearchWrapperMobile = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const FieldSearchMobile = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const FieldSearchDropdownMobile = styled.div`
  position: absolute;
  min-width: ${({ theme }) => theme.spacing(38)};
`;
